import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useApi } from "../../utils/api";
import Loading from "../Layout/Loading";

const CoachingConnectedAccountRefresh = () => {
  const { createAccountLink } = useApi();
  const { accountId } = useParams();
  useEffect(() => {
    const getAccountLink = async () => {
      const accountLink = await createAccountLink(accountId);
      if (!accountLink.url) {
        setError(
          "Failed to create account link. Please try again. Error: " +
            accountLink.statusText
        );
      }
      window.location.href = accountLink.url;
    };
    getAccountLink();
  }, [accountId]);
  return <Loading style={{ m: 4 }} />;
};

export default CoachingConnectedAccountRefresh;
